import { useMaestroStore } from '../store/maestroStore';

/** Where a listening-session event came from: OS token and web build and the session context read from the store (split out of the telemetry hook for the file-size gate). */

export function platformToken() {
  try {
    const os = window.__MAESTRO_DESKTOP_OS__ || window.__MAESTRO_CONNECTOR__?.platform;
    if (os) return String(os).toLowerCase().includes('win') ? 'windows' : 'macos';
    if (window.__maestroNative__ || window.webkit?.messageHandlers) return 'ios';
  } catch { /* ignore */ }
  return 'web';
}

export function webVersion() {
  try { return typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : null; } catch { return null; }
}

// Only id prefixes that name a path — never a device's own UDN.
export const rendererKind = (id) => (/^(local-native:|raat-uuid:|raat-|qconnect|local_computer|this_computer|this_device)/i.exec(String(id || '')) || [])[1]?.toLowerCase() || null;

export function sessionContext() {
  const s = useMaestroStore.getState();
  const zone = s.discovery?.activeZone || null;
  const md = zone?.metadata || {};
  const track = s.currentTrack || {};
  const queueLen = Array.isArray(s.queue) ? s.queue.length : 0;
  const albumIds = new Set((s.queue || []).slice(0, 40).map((q) => q?.track?.albumId).filter(Boolean));
  let context = 'tracks';
  if (s.activeSource === 'radio') context = 'radio';
  else if (track.playlistContext) context = 'playlist';
  else if (queueLen >= 2 && albumIds.size === 1) context = 'album';
  else if (queueLen >= 2) context = 'playlist';
  const zoneType = zone?.type || '';
  const transport = md.transport_type || (zoneType === 'local-native' ? 'local-native' : zoneType === 'browser' ? 'browser' : zoneType || null);
  return {
    context,
    queue_len: queueLen,
    source: track.source || null,
    renderer_manufacturer: md.manufacturer || null,
    renderer_model: md.model || null,
    transport_type: transport,
    renderer_kind: rendererKind(zone?.id),
  };
}
